import {Injectable} from '@angular/core';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let gtag: Function;

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsService {
    constructor() {}

    sendAnalytics(): void {
        gtag('event', 'page_view', {
            page_location: window.location.href,
        });
    }
}
